module.exports = __webpack_public_path__ + "img/phone.ef9c4acc.svg";